import React from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch, useLocation } from "react-router-dom";
import * as API from "../../lib/api.js";
import * as Links from "../../lib/links.js";
import { setAccount } from "../../store/panel.js";

import Menu from "../Menu/Menu.jsx";

import Account from "../../containers/Account.jsx";
import Dashboard from "../../containers/Dashboard.jsx";
import Help from "../../containers/Help.jsx";
import Login from "../../containers/Login.jsx";
import Logout from "../../containers/Logout.jsx";
import Register from "../../containers/Register.jsx";
import Subscription from "../../containers/Subscription.jsx";
import Website from "../../containers/Website.jsx";
import { useReduxAccount } from "../../hooks/useReduxAccount.jsx";
import Action from "../Action/Action.jsx";

import ROUTES from "../../lib/routes.js";

export const NAME2CONTAINER = {
    Account,
    Dashboard,
    Login,
    Logout,
    Subscription,
    Help,
    Website,
    Register,
};

export { ROUTES };

/* export const ROUTES = {
    guest: [
        { Container: Login, path: "/" },
        { Container: Login, path: "/login" },
        { Container: Login, path: "/login/restoring-access", props: { restoring: true } },
        { Container: Register, path: "/register" },
        { Container: Register, path: "/register/:plan" },
    ],

    user: [
        { Container: Dashboard, path: "/", use: ["Menu"] },
        { Container: Account, path: "/account", use: ["Menu"], props: { account: true } },
        { Container: Account, path: "/account/password", use: ["Menu"], props: { recovery: true } },
        { Container: Dashboard, path: "/dashboard", use: ["Menu"] },
        { Container: Logout, path: "/logout" },
        { Container: Subscription, path: "/subscription", use: ["Menu"] },
        { Container: Help, path: "/help", use: ["Menu"] },
        { Container: Website, path: "/website/:id/design", props: { design: true } },
        { Container: Website, path: "/website/:id/analytics", use: ["Menu"], props: { analytics: true } },
        { Container: Website, path: "/website/:id/marketing", use: ["Menu"], props: { marketing: true } },
        { Container: Website, path: "/website/:id/domain", use: ["Menu"], props: { domain: true } },
        { Container: Website, path: "/website/:id/content", props: { content: true } },
        { Container: Website, path: "/website/:id/content/:step", props: { content: true } },
        { Container: Website, path: "/website/new", props: { new: true } },
    ],
}; */

function Routes() {
    const location = useLocation();

    const dispatch = useDispatch();
    const [isCheckEnd, setIsCheckEnd] = React.useState(false);
    const account = useReduxAccount();

    const guest = [];
    const user = [];

    for (const route of ROUTES.guest) {
        const newRoute = { ...route };
        newRoute.Container = NAME2CONTAINER[route.ContainerName];
        guest.push(newRoute);
    }

    for (const route of ROUTES.user) {
        const newRoute = { ...route };
        newRoute.Container = NAME2CONTAINER[route.ContainerName];
        user.push(newRoute);
    }

    React.useEffect(() => {
        API.AccountCheck()
            .then(res => {
                if (!res?.ok) {
                    return null;
                }

                delete res.ok;
                return res;
            })
            .then(account => {
                dispatch(setAccount(account));
                setIsCheckEnd(true);
            })
            .catch(e => {
                console.log(e);
            });
    }, []);

    if (!isCheckEnd) {
        return null;
    }

    return (
        <Switch location={location}>
            <Route path="/a/:hash" exact={true}>
                <Action />
            </Route>

            {!account &&
                guest.map(({ path, Container, props }) => (
                    <Route key={path} path={path} exact={true}>
                        <Container {...props} isLoggedIn={false} />
                    </Route>
                ))}

            {account &&
                user.map(({ path, Container, use, props }) => (
                    <Route key={path} path={path} exact={true}>
                        {use && use.includes("Menu") && <Menu />}
                        <Container {...props} isLoggedIn={true} />
                    </Route>
                ))}

            <Route path="*">
                <Redirect to={account ? Links.Dashboard() : Links.Login()} />
            </Route>
        </Switch>
    );
}

export default function Router(props) {
    return (
        <BrowserRouter location={props.url}>
            <Routes />
        </BrowserRouter>
    );
}
